<template>
    <div class="page">
        <div class="auth-container">
            <el-row type="flex" justify="center" class="auth-logo-row" :gutter="15">
                <el-col :xs="{span:24}" :span="12" >
                    <img class="auth-logo" src="../../assets/images/AuthPageLogo.png"/>
                </el-col>
            </el-row>
            <transition name="el-fade-in-linear">
                <router-view></router-view>
            </transition>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AppAuth'
    }
</script>

<style lang="scss" scoped>
    .page {

        background-image: linear-gradient(180deg, #eef4fa, #f0f7fd 85%, #fff);
        .auth-container {
            .auth-logo-row {
                margin: 0 !important;

                .el-col {
                    margin: 10% 0 2% 0;
                    .auth-logo {
                        max-height: 100px;
                    }
                }
            }
            height: 95vh;
        }
    }

</style>
